<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-shopping-cart card-file-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div v-if="message_sent_stat_addon && node.data.uniqueId" class="text_message">
        {{ message_sent_lang }} : {{displayStat(node.data.uniqueId)}}
      </div>

      <div class="card-data">
        <div v-if="isStoreSelected(node) && isProductSelected(node)">
          <p class="text-center mb-2 postback_title"  v-if="node.data.ecommerceStoreText">{{ node.data.ecommerceStoreText }}</p>

          <div class="typing_delay clearfix mb-2 p-1 pl-3 pr-3" v-if="node.data.IsTypingOnDisplayChecked">
            <p class="typing_display float-left mb-0 p-0">
              <img :src="baseUrl + 'assets/pre-loader/typing_on.gif'" height="9px" width="20px"> {{ typing_display }}
            </p>
            <p class="delay_time float-right mb-0" v-if="node.data.delayReplyFor">
              {{ node.data.delayReplyFor }} {{ sec }}
            </p>
          </div>

          <div v-if="node.data.ecommerceStoreText && node.data.ecommerceButtonTextValue && isSlider(node)" id="slideshow">
            <div v-for="(item,index) in node.data.ecommerceProductText" :key="item" class="card mb-2 css-only-carousel-cell">
              <img class="card-img-top" :src="baseUrl + 'upload/ecommerce/' + node.data.ecommerceProductThumbnail[index]"/>
              <div class="card-body p-2">
                <h5 class="card-title mb-0">{{ item }}</h5>
                <p class="card-text text-muted mt-0 mb-2">{{ node.data.ecommerceStoreCurrency }} {{ node.data.ecommerceProductPrice[index] }}</p>
                <a href="#" class="btn btn-sm btn-primary" v-if="node.data.ecommerceButtonTextValue">{{ node.data.ecommerceButtonTextValue }}</a>
              </div>
            </div>
          </div>

          <div v-if="node.data.ecommerceStoreText && node.data.ecommerceButtonTextValue && !isSlider(node)">
            <div v-for="(item,index) in node.data.ecommerceProductText" :key="item" class="card mb-2">
              <img class="card-img-top" :src="baseUrl + 'upload/ecommerce/' + node.data.ecommerceProductThumbnail[index]"/>
              <div class="card-body p-2">
                <h5 class="card-title mb-0">{{ item }}</h5>
                <p class="card-text text-muted mt-0 mb-2">{{ node.data.ecommerceStoreCurrency }} {{ node.data.ecommerceProductPrice[index] }}</p>
                <a href="#" class="btn btn-sm btn-primary" v-if="node.data.ecommerceButtonTextValue">{{ node.data.ecommerceButtonTextValue }}</a>
              </div>
            </div>
          </div>      

          

        </div>
      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div class="output text-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { lang } from '../../assets/lang'
import { templateComponentMethods } from '../../functions/utils'

export default {
  name: 'EcommerceTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    sec: lang.common_info_sec,
    baseUrl: window.xitFlowBuilderData.base_url,
    typing_display: lang.common_info_typing_display,
    message_sent_lang: lang.message_sent_lang,
    message_sent_stat_addon: window.xitFlowBuilderData.message_sent_stat_addon,
  }),

  methods: {
    ...templateComponentMethods,

    isStoreSelected(node) {
      return node.data.ecommerceStoreValue && node.data.ecommerceStoreText
    },
    
    isProductSelected(node) {
      return node.data.ecommerceProductValue && node.data.ecommerceProductText
    },

    isSlider(node) {
      return node.data.ecommerceProductValue && node.data.ecommerceProductValue.length>1
    },

    displayProductList(node) {
      if (this.isProductSelected(node)) {
        return Array.isArray(node.data.ecommerceProductText) 
          ? node.data.ecommerceProductText.join(', ')
          : ''
      }
    },
  }
}
</script>

<style scoped>
.single_button { 
  font-weight: 500;
  background-color: #D8DADF;
  padding: 3px 20px 5px 20px;
  border-radius: 7px;
  text-transform: capitalize;
  font-size: 11px;
  margin: 5px 40px;
}
.shop_name {
  margin-bottom: -8px;
  font-size: 18px;
  /*font-family: Garamond;*/
  font-weight: 900;
}
.products_list {color: #8d8d8d; }
.input_content { width:50% !important;margin-top: 25px;}
.output_content{ width:50% !important;float:right !important;}
.card-sockets { padding: 5px 0 !important;}
.xit-fb-template.hasData { min-width: 240px !important; }
</style>